/**
 * @package paginate
 */

import HTTPService from './common/services/HTTPService.es6';
import spinnerTemplate from './common/templates/spinner-dots.html';
import * as toaster from './common/toaster.es6';
import Wa from './common/wa';
import { init as tooltipInit } from './tooltip';

export default function Paginate() {
    /**
     * Container of the pagination controls
     */
    let $paginationContainer;

    let paginationContainerSelector;

    /**
     * Container of the result list
     */

    let $listContainer;

    let currentPage = 1;

    let paginationLoading = false;

    let currentFeedbackType = null;

    let currentFeedbackSort = null;

    let showPageDataCallback = () => {};

    let pageLoadedCallback = () => {};

    let paginateWithLink = false;

    let dataSearchUrl = '';

    function refetchPaginationControls() {
        $paginationContainer = $(paginationContainerSelector); // Refetch DOM because element has been removed by XHR request
        currentPage = Number($paginationContainer.find('[data-paginate-current]').html());
    }

    function _showPage({ url = dataSearchUrl, $button = null }) {
        if (typeof url !== 'string') {
            throw new TypeError(`url params must be a string, ${typeof url} received`);
        }

        if (paginationLoading === true) {
            return;
        }

        paginationLoading = true;

        const buttonText = $button?.html();

        const $paginateStatus = $listContainer.find('[data-paginate-status]');

        const $loadingWrapper = $('#loadingWrapper');
        $loadingWrapper.addClass('loading-wrapper--loading');
        if ($paginateStatus.length > 0) {
            $paginateStatus.after(spinnerTemplate({ classes: 'spinner--dots-inline' }));
            $paginateStatus.addClass('hide');
        } else if ($button) {
            $button.html(spinnerTemplate({ classes: 'spinner--dots-inline spinner--dots-small' }));
        }

        let data = {
            page: currentPage,
        };

        if ($listContainer.data('feedback-container') !== undefined) {
            if (currentFeedbackType) {
                data.type = currentFeedbackType;
            }
            if (currentFeedbackSort) {
                data.sort = currentFeedbackSort;
            }
        }

        if (typeof showPageDataCallback === 'function') {
            data = $.extend(data, showPageDataCallback());
        }

        HTTPService.getHTML(url || $button.data('url'), data).then(
            response => {
                window.scrollTo(
                    0,
                    // Navbar offset 58px
                    $listContainer.parents('[data-pagination-scroll-target]').offset().top - 58,
                );

                $listContainer.html(response.data);
                refetchPaginationControls();

                $listContainer.find('img').unveil(0, function unveilHandler() {
                    $(this).on('load', function onImageLoad() {
                        $(this).css({ width: '', height: '' });
                    });
                });

                tooltipInit($listContainer);
                Wa.setTracking($listContainer, MA.Context.waData);

                $paginationContainer.find($('[data-spinner]')).remove();
                paginationLoading = false;
                $loadingWrapper.removeClass('loading-wrapper--loading');
                if ($paginateStatus.length > 0) {
                    $paginateStatus.removeClass('hide');
                }

                if (typeof pageLoadedCallback === 'function') {
                    pageLoadedCallback();
                }
                if ($button) $button.html(buttonText);
            },
            () => {
                paginationLoading = false;
                toaster.displayErrorToaster(
                    'Un problème est survenu lors du chargement de la page, veuillez réessayer ultérieurement.',
                );
                if ($button) $button.html(buttonText);
            },
        );
    }

    function setPageParam() {
        const params = new URLSearchParams(window.location.search);

        if (currentPage === 1) params.delete('p');
        else params.set('p', currentPage);

        window.history.pushState(
            {},
            '',
            `${window.location.pathname}${params.toString() ? `?${params}` : ''}`,
        );
    }

    function init(paginationSelector, listSelector, _showPageDataCallback, _pageLoadedCallback) {
        $paginationContainer = $(paginationSelector);
        $listContainer = $(listSelector);
        showPageDataCallback = _showPageDataCallback;
        pageLoadedCallback = _pageLoadedCallback;
        paginationContainerSelector = paginationSelector;
        currentPage = Number($paginationContainer.find('[data-paginate-current]').html());
        paginateWithLink = $paginationContainer.attr('data-paginate-with-link') !== undefined;

        if (paginateWithLink) {
            dataSearchUrl = $paginationContainer.data('url');
            window.onpopstate = e => {
                const params = new URLSearchParams(e.target.location.search);
                currentPage = params.get('p') || 1;
                _showPage({ url: dataSearchUrl });
            };
        }

        $listContainer.on('click', '[data-paginate-next]', function onPaginateNext(e) {
            const $this = $(this);
            e.preventDefault();
            currentPage += 1;
            if (paginateWithLink) setPageParam(currentPage);
            _showPage({ $button: $this });
        });

        $listContainer.on('click', '[data-paginate-previous]', function onPaginatePrevious(e) {
            const $this = $(this);
            e.preventDefault();
            currentPage -= 1;
            if (paginateWithLink) setPageParam(currentPage);
            _showPage({ $button: $this });
        });

        $listContainer.on('click', '[data-paginate-page]', function onPaginatePage(e) {
            const $this = $(this);
            e.preventDefault();
            currentPage = parseInt($(this).attr('data-paginate-page-num'), 10);
            if (paginateWithLink) setPageParam(currentPage);
            _showPage({ $button: $this });
        });

        if ($listContainer.data('feedback-container') !== undefined) {
            $('[data-feedback-select-type]').on('change', function onFeedbackTypeChange(e) {
                const $this = $(this);
                e.preventDefault();
                currentPage = 1;
                currentFeedbackType = $(this).val();
                _showPage({ $button: $this });
            });

            $('[data-feedback-select-sort]').on('change', function onFeedbackSortChange(e) {
                const $this = $(this);
                e.preventDefault();
                currentPage = 1;
                currentFeedbackSort = $(this).val();
                _showPage({ $button: $this });
            });
        }
    }

    return {
        init,
        refetchPaginationControls,
    };
}
